declare namespace $ {

	type $mol_view__sub_bog_builderui_studio_pick_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_pick_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_studio_pick_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_builderui_studio_pick extends $mol_select {
		Label( ): $mol_view
		Value( ): $mol_view
		Texts( ): $mol_view
		Dot( ): $mol_view
		label( ): string
		dot_color( ): string
		style( ): ({ 
			'--bog_builderui_studio_pick_dot': ReturnType< $bog_builderui_studio_pick['dot_color'] >,
		}) 
		trigger_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=pick.view.tree.d.ts.map